import React from "react";
import { useNavigate } from "react-router-dom";
import "./Terms.css";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="glass-background"></div>

      {/* NAVBAR */}
      <nav className="legal-nav">
        <div className="nav-brand" onClick={() => navigate("/")}>
          <img src="/icons/logo-512.png" className="nav-logo" alt="GrammAA" />
          <span className="brand-text">GrammAA</span>
        </div>
      </nav>

      {/* CONTENT */}
      <div className="legal-content glass-panel fade-in">
        <h1>Terms & Conditions</h1>
        <p className="updated-date">Last updated: {new Date().getFullYear()}</p>

        <p>
          Welcome to <strong>GrammAA</strong>. These Terms & Conditions govern your
          access to and use of our website, tools, and services.
        </p>

        <h2>1. Use of Service</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the platform for illegal purposes.</li>
          <li>Bypass security or usage limits.</li>
          <li>Reverse engineer our backend.</li>
          <li>Upload harmful or abusive content.</li>
        </ul>

        <h2>2. Accounts & Security</h2>
        <p>
          You are responsible for protecting your login credentials. We are not
          responsible for unauthorized access caused by weak passwords or unsafe login behavior.
        </p>

        <h2>3. Free & Premium Plans</h2>
        <p>
          Free users get limited daily checks. Premium users receive unlimited access.
          Features may change based on updates.
        </p>

        <h2>4. Payments & Billing</h2>
        <p>All payments are processed securely via Razorpay. By purchasing:</p>
        <ul>
          <li>Your billing details must be accurate.</li>
          <li>You get access for the purchased duration.</li>
          <li>Chargeback abuse may lead to account termination.</li>
        </ul>

        <h2>5. Refund Policy</h2>
        <p>
          Refunds follow our official policy.
          See: <a href="/refund">Refund Policy</a>
        </p>

        <h2>6. Content & Data Usage</h2>
        <p>
          Text submitted for grammar checking is processed securely. We do NOT sell or misuse your data.
        </p>

        <h2>7. Intellectual Property</h2>
        <p>
          All design, branding, UI, and backend belong to <strong>aiwebAA.com</strong>.
        </p>

        <h2>8. Service Availability</h2>
        <p>
          We aim for 100% uptime but do not guarantee uninterrupted access.
        </p>

        <h2>9. Termination</h2>
        <p>
          Accounts violating our terms may be suspended or terminated.
        </p>

        <h2>10. Changes</h2>
        <p>
          We may update these terms anytime. Continued use means you accept updates.
        </p>

        <h2>11. Contact Us</h2>
        <p>
          Email: <strong>support@aiwebaa.com</strong>
        </p>
      </div>
    </div>
  );
};

export default Terms;
